import { Controller } from "@hotwired/stimulus"

// Przełącza widoczność pola NIP w formularzu nabywcy rozliczenia: pole
// pokazuje się tylko, gdy wybrano "Firma" (mirror walidacji Settlement —
// buyer_nip wymagany tylko dla buyer_kind == "firma").
export default class extends Controller {
  static targets = ["nipField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const checked = this.element.querySelector('input[name$="[buyer_kind]"]:checked')
    const isFirma = checked && checked.value === "firma"
    this.nipFieldTargets.forEach((el) => el.classList.toggle("hidden", !isFirma))
  }
}
